import React, {useState, useEffect} from 'react';
import {useTranslation} from "react-i18next";
import AccordionTab from "../../components/UI/Accordion/AccordionTab"
import PageTitle from "../../components/Commons/PageTitle";
import Helpbox from "../../components/UI/Helpboxes/Helpbox";
import Spinner from "../../components/UI/Spinner";
import Aux from "../../hoc/Auxiliary";
import parse from "html-react-parser";
import axios from "../../axios-defaults";

const Faq = (props) => {
    const {t, i18n} = useTranslation();
    const [loading, setLoading] = useState(false);
    const [loadingSection, setLoadingSection] = useState(false);
    const [faq, setFaq] = useState('');
    const [faqSections, setFaqSections] = useState('');
    const [faqFreq, setFaqFreq] = useState('');

    useEffect(() => {
        setLoading(true);
        setLoadingSection(true);

        async function getFaq(parentCat) {
            await axios.get(`/wordpress/v2/cpt_faq?per_page=100&ctx_typeFaq=` + parentCat)
                .then(response => {
                    let FaqsArray = [];
                    let FaqsFreqArray = [];
                    if (Array.isArray(response.data) && response.data.length > 0) {
                        let data = response.data.sort((a, b) => parseInt(a.acf.priority) > parseInt(b.acf.priority) ? 1 : -1);
                        data.forEach((item) => {
                            if (item.acf.frequently_asked == 1) {
                                FaqsFreqArray.push({
                                    title: item.title.rendered,
                                    priority: item.acf.priority,
                                    content: item.content.rendered,
                                });
                            } else {
                                FaqsArray.push({
                                    title: item.title.rendered,
                                    priority: item.acf.priority,
                                    content: item.content.rendered,
                                    cat: item.ctx_typeFaq
                                    //cat: item.ctx_typeFaq.filter(e => e !== this.state.parentCat)[0]
                                });
                            }
                        });
                    }
                    setFaq(FaqsArray)
                    setFaqFreq(FaqsFreqArray)
                    setLoading(false);
                }).catch(error => {
                    setLoading(false);
                });
        }

        async function getFaqSections(parentCat) {
            await axios.get(`/wordpress/v2/ctx_typefaq?parent=` + parentCat)
                .then(response => {
                    let FaqSectionsArray = [];
                    if (Array.isArray(response.data) && response.data.length > 0) {
                        response.data.forEach((item) => {
                            FaqSectionsArray.push({
                                title: item.name,
                                catID: item.id
                            });
                        });
                    }
                    setFaqSections(FaqSectionsArray);
                    setLoadingSection(false);

                }).catch(error => {
                    setLoadingSection(false);
                });
        }

        let idParentCat = i18n.language === "fr" ? PARENTCATEGORIE_FR : PARENTCATEGORIE_EN;
        getFaq(idParentCat);
        getFaqSections(idParentCat);

    }, [i18n.language])


    let accordionContent = null;
    let accordionFreq = <Spinner styleName={props.view == "dashboard" ? 'white centered' : '' }/>;

    if (!loading && !loadingSection && Array.isArray(faq) && faq.length > 0) {
        if (props.view == "dashboard") {
            if (Array.isArray(faqFreq) && faqFreq.length > 0) {
                accordionFreq = (
                    <Aux>
                        {(faqFreq.length > 0)
                            ? (<Aux>
                                {
                                    faqFreq.map((item) => {
                                        return <AccordionTab key={item.title} title={item.title}
                                                             priority={item.priority}>
                                            {parse(item.content)}
                                        </AccordionTab>
                                    })
                                }
                            </Aux>)
                            : ''
                        }
                    </Aux>
                )
            }
        } else {

            if (Array.isArray(faqFreq) && faqFreq.length > 0 || Array.isArray(faq) && faq.length > 0) {
                accordionFreq =
                    <Aux>
                        <h2 className="headline headline--section headline--margin--20 headline--no-transform">
                            {t("faq.freqasked")}</h2>

                        <div className="accordions__block">
                            {(faqFreq.length > 0)
                                ? (<Aux>
                                    {
                                        faqFreq.map((item) => {
                                            return <AccordionTab key={item.title} title={item.title}
                                                                 priority={item.priority}>
                                                {parse(item.content)}
                                            </AccordionTab>
                                        })
                                    }
                                </Aux>)
                                : ''
                            }
                            { /* SHOW UNCLASSIFIED IN FREQUENTLY ASKED */ }
                            {(faq.length > 0) ? <Aux>
                                {faq.map((faqitem) => {
                                        if (faqitem.cat.length == 1) {
                                            return <AccordionTab key={faqitem.title} title={faqitem.title}
                                                                 priority={faqitem.priority}>
                                                {parse(faqitem.content)}
                                            </AccordionTab>
                                        }
                                    }
                                )}

                            </Aux> : ''}
                        </div>


                    </Aux>
            } else {
                accordionFreq = null;
            }

                if (Array.isArray(faq) && faq.length > 0 &&
                    Array.isArray(faqSections) && faqSections.length > 0) {

                    accordionContent = (
                        <Aux> {
                            faqSections.map((faqsectionitem) => {
                                //console.log(faq)
                                return (
                                    <Aux key={faqsectionitem.catID}>
                                        <h2 className="headline headline--section headline--margin--20 headline--no-transform">{faqsectionitem.title}</h2>
                                        <div className="accordions__block">
                                            {faq.map((faqitem) => {
                                                    if (faqitem.cat.includes(faqsectionitem.catID)) {
                                                        return <AccordionTab key={faqitem.title} title={faqitem.title}
                                                                             priority={faqitem.priority}>
                                                            {parse(faqitem.content)}
                                                        </AccordionTab>
                                                    }
                                                }
                                            )}
                                        </div>
                                    </Aux>
                                )
                            })
                        }

                        </Aux>
                    )
                } else {


                    if (Array.isArray(faq) && faq.length > 0) {
                        accordionContent = (
                            <Aux>
                                <h2 className="headline headline--section headline--margin--20 headline--no-transform">
                                    {t("faq.freqasked")}</h2>
                                <div className="accordions__block">
                                    {faq.map((faqitem) => {
                                            return <AccordionTab key={faqitem.title} title={faqitem.title}
                                                                 priority={faqitem.priority}>
                                                {parse(faqitem.content)}
                                            </AccordionTab>
                                        }
                                    )}
                                </div>
                            </Aux>
                        )
                    } else {

                          accordionContent = (
                              <Aux>
                                  {t("faq.nodata")}
                              </Aux>
                          )
                    }
                }
            }
        }

        return (
            <Aux>
                {props.view == "dashboard" ? accordionFreq :

                    <div className="container container--larger faqs">
                        <div className="row flex flex--wrap flex--align-baseline">
                            <div className="col-lg-5">
                                <PageTitle title={t("faq.needhelp")}/>
                            </div>
                            <div className="col-lg-7">
                                {location.pathname != '/faq-ug' && <Helpbox cta={true} type="invoice" />}
                            </div>
                        </div>
                        <br/>
                        <div className="accordions">
                            {accordionFreq}
                            {accordionContent}
                        </div>
                        <div className="mt-4">
                            <Helpbox cta={true} />
                        </div>
                    </div>}

            </Aux>
        )

    }
    ;

    export default Faq;
